import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Col, Row, FormGroup } from "react-bootstrap";
import {
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
  stufeetypelist,
} from "../../../services/master";
import {
  academylist,
  studentdetailinfees,
  studentfeelist,
  studentinvoicefee,
  studentonlinefeepayment,
} from "../../../services/admin";
import moment from "moment";
import { toast } from "react-toastify";
import { studentfilter } from "../../../services/student";
import Select from "react-select";

// Builds the fee label. When the fee belongs to a specific month
// (fee_month = "YYYY-MM"), append the month name, e.g. "Van Fees (March)".
function feeLabel(fee) {
  if (fee.fee_month) {
    const m = moment(fee.fee_month, "YYYY-MM");
    if (m.isValid()) {
      return `${fee.fee_type} (${m.format("MMMM YYYY")})`;
    }
  }
  return fee.fee_type;
}

export default function AddFee() {
  // const [fees, setFees] = useState([
  //   { id: 1, name: "Admission Fee", amount: 1000, due: 1000, status: "Unpaid", paidAmount: 0, fine: 0 },
  //   { id: 2, name: "Tuition Fee", amount: 5000, due: 5000, status: "Unpaid", paidAmount: 0, fine: 0 }
  // ]);

  const handleChange = (id, field, value) => {
    const regex = /^[0-9\b]+$/;
    if (value === "" || regex.test(value)) {
      setFList(flist.map(fee => {
        if (fee.id !== id) return fee;
        let v = value;
        // Due amount can't exceed what's still pending on this fee.
        if (field === "due_amount" && value !== "") {
          const pending = parseFloat(fee.pending_amount) || 0;
          if (parseFloat(value) > pending) {
            v = String(pending);
            toast.error(`"${feeLabel(fee)}" cannot exceed the pending amount ${pending}`);
          }
        }
        return { ...fee, [field]: v };
      }));
    }


  };

  // const totalPaid = fees.reduce((sum, f) => sum + Number(f.paidAmount || 0), 0);
  // const totalFine = fees.reduce((sum, f) => sum + Number(f.fine || 0), 0);

  const [alist, setAList] = useState([]);
  const [clslist, setClsList] = useState([]);
  const [seclist, setSecList] = useState([]);
  const [stulist, setStuList] = useState([]);
  const [slist, setSList] = useState([]);

  const [ayear, setAYear] = useState("");
  const [stucls, setStuCls] = useState("");
  const [stusec, setStuSec] = useState("");
  const [stuid, setStuId] = useState("");

  const [admno, setAdmno] = useState("");
  const [ftype, setFType] = useState("");

  const [tamt, setTAmt] = useState("");
  const [pamt, setPAmt] = useState("");

  const [remark, setRemark] = useState("");
  const [damt, setDAmt] = useState("");
  const [pendamt, setPendAmt] = useState("");
  const [paymet, setPaymet] = useState("Offline");
  const [pdate, setPdate] = useState("");
  const [spush, setSpush] = useState(true); // notify parent on payment
  const [ptype, setPType] = useState("Current");

  const [aclist, setAcList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [flist, setFList] = useState([]);

  const [hpen, setHPen] = useState(0);


  useEffect(() => {

    if (localStorage.getItem("ADate") !== '') {
      setPdate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
    } else {
      setPdate(moment(new Date()).format("YYYY-MM-DD"));
    }



    stuclasslist().then((res) => {
      if (res.status === true) {
        setClsList(res.data);
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        setSecList(res.data);
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAcList(arr);
        }
      }
    });

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listyaer(arr[0]);
                setAYear(localStorage.getItem("AYear") || "");
              }
            }

          }
        }
      });
    } else {
      listyaer("");
    }
  }, []);

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/user.png");
    ev.target.onerror = null;
  }

  // const handleChange = (e) => {
  //   const regex = /^[0-9\b]+$/;
  //   if (e.target.value === "" || regex.test(e.target.value)) {
  //     setTAmt(e.target.value);
  //     setPendAmt(e.target.value - pamt - damt);
  //   }
  // };

  const handlePaid = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPAmt(e.target.value);
      setPendAmt(tamt - e.target.value - damt);
    }
  };

  const handleDisc = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setDAmt(e.target.value);

    }
  };

  const [fpath, setFpath] = useState("");
  const [fdetail, setFdetail] = useState("");
  function feecheck(e) {
    e.preventDefault();
    if (e.target.value != "") {
      studentdetailinfees(e.target.value).then((res) => {
        if (res.status === true) {
          setFpath(res.data.path);
          if (res.data.details !== null) {
            setFdetail(res.data.details);
          }
        }
      });
    }
  }

  function filterstu(aca, yr, cl, se) {
    setFpath("");
    setStuList([]);
    setSList([]);
    setFdetail("");
    setStuId("");
    if (cl !== "" && cl !== null && se !== "" && se !== null) {
      const temp = new FormData();
      if (yr && yr !== "null") {
        temp.append("year", yr);
      }
      temp.append("class", cl);
      temp.append("section", se);
      if (localStorage.getItem("Role") === "1" && aca !== "") {
        temp.append("academy", aca.value);
      }
      studentfilter(temp).then((res) => {
        if (res.status === true) {
          setFpath(res.data.path);
          setSList(res.data.details);
          let arr = [];

          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              arr.push({
                value: res.data.details[i].id,
                label: res.data.details[i].username + " - " + res.data.details[i].student_name,
              });
            }
          }
          setStuList(arr);
        }
      });
    }
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      filterstu(e, ayear, stucls, stusec);
      listyaer(e)
    } else {
      setAcaID("");
      filterstu("", ayear, stucls, stusec);
      listyaer("");
    }
  }
  function listyaer(aid) {
    setAList([]);
    setAYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        setAList(res.data);
      }
    });
  }
  function handleStu(e) {
    setFdetail("");
    setFType("");
    setTAmt("");
    setDAmt("");
    setPAmt("");
    setPendAmt("");
    setErrormsg("");
    if (e !== null) {
      setStuId(e);
      if (slist.length > 0) {
        const rdata = slist.find((item) => item.id == e.value);
        if (rdata !== undefined) {

          setFdetail(rdata);
        }
      }

    } else {
      setStuId("");
      setFdetail("");
    }
  }

  function feeall() {
    setDAmt("");
    setFList([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && acaid !== "") {
      temp.append("academy_id", acaid.value);
    }
    temp.append("year_id", ayear);
    temp.append("class_id", stucls);
    temp.append("section_id", stusec);
    temp.append("student_id", stuid?.value);
    temp.append("admission_no", admno);
    studentfeelist(temp).then((res) => {
      if (res.status === true) {
        // setFList(res.data);
        const sdata = res.data.map((item) => {
          return {
            ...item,
            due_amount: 0,
          }
        })
        setFList(sdata);
        setDAmt(sdata[0]?.student_discount || 0);

      }
    })
    //     console.log(slist,stuid?.value);

    // if (slist.length > 0) {
    //     const rdata = slist.find((item) => item.id == stuid?.value);
    //     if (rdata !== undefined) {
    //       // if (rdata.photo !== null) {
    //       setDAmt(rdata?.discount_per || 0);
    //     }
    //   }
  }
  const [errormsg, setErrormsg] = useState("");
  const navigate = useNavigate();
  function feesubmit(e) {
    e.preventDefault();
    let valid = "";
    setErrormsg("")

    if (localStorage.getItem("Role") === "1" && !acaid) {
      setErrormsg("Please Select Academy");
      return;
    }


    if (!ayear) return setErrormsg("Please Select Academic Year");
    if (!stucls) return setErrormsg("Please Select Class");
    if (!stusec) return setErrormsg("Please Select Section");
    if (!stuid) return setErrormsg("Please Select Student");
    if (!paymet) return setErrormsg("Please Select Payment Method");
    if (!pdate) return setErrormsg("Please Select Payment Date");

    // if (parseFloat(pamt) > (parseFloat(tamt) - parseFloat(damt))) {
    //   return setErrormsg("Paid amount cannot be greater than " + (parseFloat(tamt) - parseFloat(damt)));
    // }

    // const temp = new FormData();

    // if (localStorage.getItem("Role") === "1" && acaid) {
    //   temp.append("academy_id", acaid.value);
    // }

    // temp.append("class_id", stucls);
    // temp.append("section_id", stusec);
    // temp.append("adm_year", ayear);
    // temp.append("student_id", stuid.value);

    // // Append all selected fee types (as JSON string if needed)
    // const feeTypeValues = ftype.map(f => f.value);
    // temp.append("type", JSON.stringify(feeTypeValues));

    // temp.append("total", tamt);
    // temp.append("paid", pamt);
    // temp.append("pending", pendamt);

    // temp.append("discount", damt);
    // temp.append("paymethod", paymet);
    // temp.append("paid_date", pdate);
    // temp.append("remarks", remark);

    // temp.append("user_id", localStorage.getItem("UID"));

    const globalDiscount = parseFloat(damt) || 0;

    // Step 1: Filter only rows with paid_amount > 0
    const payingItems = flist.filter(item => parseFloat(item.due_amount) > 0);
    const payingCount = payingItems.length;

    let equalDiscount = 0;
    if (globalDiscount > 0 && payingCount > 0) {
      equalDiscount = parseFloat((globalDiscount / payingCount).toFixed(2));
    }

    // Step 2: Validate all items
    for (let item of flist) {
      // Cap against what's still owed (pending), not the original total — a
      // partially paid fee can only take up to its remaining balance.
      const pending = parseFloat(item.pending_amount) || 0;
      const paid = parseFloat(item.due_amount) || 0;
      const rowDiscount = parseFloat(item.disc_amt) || 0;

      // Apply global discount only if this item has paid_amount > 0
      const applicableGlobalDisc = paid > 0 ? equalDiscount : 0;
      const totalDiscount = rowDiscount + applicableGlobalDisc;

      const effectivePending = pending - totalDiscount;
      if (paid > effectivePending) {
        return setErrormsg(
          `Paid amount for "${feeLabel(item)}" cannot exceed the pending amount ${effectivePending}`
        );
      }
    }


    // const feesArray = flist.map(item => ({
    //   academy_id: acaid?.value || localStorage.getItem("AcademyID"),
    //   adm_year: ayear,
    //   class_id: stucls,
    //   section_id: stusec,
    //   student_id: stuid?.value,
    //   user_id: localStorage.getItem("UID"),
    //   feeposting_id: item.feeposting_id,   // Or item.id depending on your structure
    //   feetype: item.feetype,
    //   fee_type: item.fee_type,             // Optional for frontend use
    //   total_amount: item.total_amount,
    //   paid_amount: item.due_amount || 0,
    //   disc_amt: item.disc_amt || 0,
    //   due_date: item.due_date
    // }));
    const feesArray = flist
      .filter(item => item.due_amount > 0)  // Only include items with due_amount > 0
      .map(item => ({
        academy_id: acaid?.value || localStorage.getItem("AcademyID"),
        adm_year: ayear,
        class_id: stucls,
        section_id: stusec,
        student_id: stuid?.value,
        user_id: localStorage.getItem("UID"),
        fee_id: item.id,                     // Exact fees_amount row being paid
        feeposting_id: item.feeposting_id,   // Or item.id depending on your structure
        feetype: item.feetype,
        fee_type: item.fee_type,             // Optional for frontend use
        fee_month: item.fee_month,           // Month this fee is for ("YYYY-MM")
        total_amount: item.total_amount,
        paid_amount: item.due_amount,
        disc_amt: item.disc_amt || 0,
        due_date: item.due_date
      }));
    const payload = {
      fees: feesArray,
      discount: damt,
      paymethod: paymet,
      paid_date: pdate,
      remarks: remark,
      send_push: spush ? 1 : 0
    };
    if (!payload.fees.length) {
      return setErrormsg("Please enter at least one fee amount.");
    }
    setLoading(true);

    studentinvoicefee(payload).then((res) => {
      if (res.status === true) {
        toast.success(res.message);
        if (paymet === "Online" && res.data.details) {
          setLoading(false);
          paynow(res.data.details.id, res.data.details.user_id, res.data.details.feeposting_id, res.data.key, res.data.RAZORPAY_SK_KEY, res.data.order_id)

          // paynow(res.data.details.id, res.data.details.user_id, res.data.details.feeposting_id, res.data.RAZORPAY_KEY, res.data.RAZORPAY_SK_KEY, res.data.order_id)
        } else {
          setLoading(false);
          navigate("/feemodule/allfee");
        }
      } else {
        setErrormsg(res.message || "Something went wrong");
      }
    });


    // Submit to backend
    // studentinvoicefee(temp).then((res) => {
    //   if (res.status === true) {
    //     toast.success(res.message);
    //     if (paymet === "Online" && res.data.details) {
    //       setLoading(false);
    //       paynow(res.data.details.id, res.data.details.user_id, res.data.details.feeposting_id, res.data.RAZORPAY_KEY, res.data.RAZORPAY_SK_KEY, res.data.order_id)
    //     } else {
    //     setLoading(false);
    //     navigate("/feemodule/allfee");
    //     }
    //   } else {
    //     setErrormsg(res.message || "Something went wrong");
    //   }
    // });
  }
  const [loading, setLoading] = useState(false);

  function paynow(did, duser, dpost, dkey, dskey, dorder) {
    const options = {
      key: dkey,
      order_id: dorder,
      // name: "dturn IT Solutions (P) Ltd",
      name: "School Tracking Academy",
      description: "Fees Payment",
      image: require("../../../assets/images/logo/logo-small.png"),
      handler: function (response) {
        const temp = new FormData();
        temp.append("payment_id", response.razorpay_payment_id);
        temp.append("order_id", dorder);
        temp.append("pay_id", did);
        temp.append("user_id", duser);
        temp.append("feeposting_id", dpost);
        setLoading(true);
        studentonlinefeepayment(temp).then((res) => {
          if (res.status === true) {
            setLoading(false);
            toast.success(res.message);
            navigate("/feemodule/allfee");
          } else {
            setErrormsg(res.message || "Something went wrong");
          }
        })
      },
      prefill: {
        email: "",
        phone_number: "",
      },
    };
    const paymentObj = new window.Razorpay(options);
    paymentObj.open();
  }

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Add Fee</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Fee Module</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Add Fee
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading &&
        <div className="content-body">
          <div className="container-fluid">
            <div className="card">

              <div className="card-body">
                <div className="row">
                    {localStorage.getItem("Role") === "1" && (

                  <div className="col-xl-4 col-lg-4">
                      <div className="mb-3">
                        <label className="form-label">
                          Select Academy{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Academy"
                          value={acaid}
                          options={aclist}
                          onChange={handleAcademy}
                          isSearchable={true}
                          isClearable
                          hidden
                        />
                      </div>
                  </div>
                    )}

                  <div className="col-xl-4 col-lg-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Academic Year
                        <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="default-select  form-control wide"
                        value={ayear}
                        onChange={(e) => { setAYear(e.target.value); setFList([]); filterstu(acaid, e.target.value, stucls, stusec); }}
                      >
                        <option value="" disabled>
                          Select Academic Year
                        </option>
                        {alist.map((item, i) => {
                          return (
                            <option value={item.id} key={i}>
                              {item.aca_year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Class <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="default-select  form-control wide"
                        value={stucls}
                        onChange={(e) => { setStuCls(e.target.value); setFList([]); filterstu(acaid, ayear, e.target.value, stusec); }}
                      >
                        <option value="" disabled>
                          Select Class
                        </option>
                        {clslist.map((item, i) => {
                          return (
                            <option value={item.id} key={i}>
                              {item.class_name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Section<span className="text-danger"> *</span>
                      </label>
                      <select
                        className="default-select  form-control wide"
                        value={stusec}
                        onChange={(e) => { setStuSec(e.target.value); setFList([]); filterstu(acaid, ayear, stucls, e.target.value); }}
                      >
                        <option value="" disabled>
                          Select Section
                        </option>
                        {seclist.map((item, i) => {
                          return (
                            <option value={item.id} key={i}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Student Name
                        <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="default-select"
                        placeholder="Select Student"
                        value={stuid}
                        options={stulist}
                        onChange={handleStu}
                        isSearchable={true}
                        isClearable
                        hidden
                      />
                    </div>
                  </div>

                </div>
                <div className="text-center mt-2 me-4">(OR)</div>
                <div className="row">
                  <div className="col-xl-4 col-lg-4">
                  </div>
                  <div className="col-xl-4 col-lg-4">
                    <div className="text-center mb-3">
                      <label className="form-label">
                        Admission Number
                        <span className="text-danger"> *</span>
                      </label>
                      <input type="text" className="form-control" placeholder="Enter Admission Number" onChange={(e) => setAdmno(e.target.value)} value={admno} />
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4">
                  </div>
                </div>
                <div className="res-right mt-2 me-4">
                  <button className="btn btn-success" onClick={feeall}>
                    Search
                  </button>
                </div>
                <hr></hr>
                {/* Fee Table */}
                <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20 }}>
                  <thead>
                    <tr style={{ background: "#f0f0f0" }}>
                      <th style={thStyle}>#</th>
                      <th style={thStyle}>Fees Name</th>
                      <th style={thStyle}>Amount</th>
                      <th style={thStyle}>Paid</th>
                      <th style={thStyle}>Pending</th>
                      <th style={thStyle}>Status</th>
                      <th style={thStyle}>Due Amount</th>
                      <th style={thStyle}>Discount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {flist.map((fee, index) => (
                      <tr key={fee.id}>
                        <td style={tdStyle}>{index + 1}</td>
                        <td style={tdStyle}>{feeLabel(fee)}</td>
                        <td style={tdStyle}>{fee.total_amount ?? 0}</td>
                        <td style={tdStyle}>{fee.paid_amount ?? 0}</td>
                        <td style={tdStyle}>{fee.pending_amount ?? 0}</td>
                        <td style={tdStyle}>
                          <span style={{
                            background: fee.status === "Paid" ? "#ccffcc" : "#ffcccc",
                            padding: "4px 8px",
                            borderRadius: "4px"
                          }}>
                            {fee.status}
                          </span>
                        </td>
                        <td style={tdStyle}>
                          {fee.status === "Paid" ? (
                            <span>{fee.due_amount}</span>
                          ) : (
                            <input
                              type="text"
                              value={fee.due_amount}
                              onChange={e => handleChange(fee.id, "due_amount", e.target.value)}
                              style={{ width: "80px" }}
                            />
                          )}
                        </td>
                        <td style={tdStyle}>
                          {fee.status === "Paid" ? (
                            <span>{fee.disc_amt ?? 0}</span>
                          ) : (
                            <input
                              type="text"
                              value={fee.disc_amt ?? 0}
                              onChange={e => handleChange(fee.id, "disc_amt", e.target.value)}
                              style={{ width: "80px" }}
                              disabled={localStorage.getItem("Role") !== "1"}
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Totals */}
                {/* <div style={{ marginBottom: 10 }}>
                <strong>Total Paid: </strong>{totalPaid} &nbsp;&nbsp;
                <strong>Total Fine: </strong>{totalFine}
              </div> */}

                {/* Payment Section */}
                <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "15px" }}>
                  <div>
                    <label>Discount</label>
                              
                    <input type="text" style={{ width: "100%" }} onChange={handleDisc} value={damt} placeholder="Enter Discount" disabled={localStorage.getItem("Role") !== "1"}/>
                  </div>
                  <div>
                    <label>Payment Method</label>
                    <select style={{ width: "100%" }} onChange={(e) => setPaymet(e.target.value)} value={paymet} disabled>
                      <option value="">Select Payment Method</option>
                      <option value="Offline">Offline</option>
                      <option value="Online">Online</option>
                    </select>
                  </div>
                  <div>
                    <label>Payment Date</label>
                    <input type="date" style={{ width: "100%" }} onChange={(e) => setPdate(e.target.value)} value={pdate} />
                  </div>
                  <div>
                    <label>Remark</label>
                    <input type="text" style={{ width: "100%" }} onChange={(e) => setRemark(e.target.value)} value={remark} placeholder="Enter Remark" />
                  </div>
                </div>
                {errormsg && <span className="text-danger">{errormsg}</span>}
                <div style={{ marginTop: 15 }}>
                  <label style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      className="styled-checkbox"
                      checked={spush}
                      onChange={(e) => setSpush(e.target.checked)}
                    />{" "}
                    Send Push Notification
                  </label>
                </div>
                <div style={{ marginTop: 20 }}>
                  <button style={{
                    background: "#28a745",
                    color: "#fff",
                    border: "none",
                    padding: "10px 20px",
                    cursor: "pointer",
                    borderRadius: "5px"
                  }} onClick={feesubmit}>
                    Confirm Payment
                  </button>
                </div>
              </div>
            </div>


          </div>
        </div>
      }
    </div >
  );
}

const thStyle = { border: "1px solid #ccc", padding: "8px", textAlign: "center" };
const tdStyle = { border: "1px solid #ccc", padding: "8px", textAlign: "center" };
